var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeroBottom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 2177.796,
    height: 650.568,
    viewBox: "0 0 2177.796 650.568",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    width: 2177.796,
    height: 501.184,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(138.588 -911.845)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "heroBg",
    transform: "translate(-138.588 1061.229)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M895.354,11.627C1050.4,9.1,1940.333,52.861,2173.955,186.677c219.467,125.709-81.967,249.829-218.369,274.6s-501.336-48.9-595.622-71.133-222.893-14.611-209.869,27.309-8.167,89.556-171.763,74.311-554.945-96.7-754.372-147.2S-32.028,234.465,40.415,186.677,584.148,16.691,895.354,11.627",
    transform: "translate(4.435 6.515)",
    fill: "#b5cc78"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "heroTree3",
    transform: "translate(138.808 1005.579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.57,225.762l.119,18.2H76.469v-18.2Z",
    transform: "translate(11.494 46.695)",
    fill: "#736357"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.274,0,42.089,75H55.025L32.107,125.268h15L17.28,190.7H37.265L0,272.457H76.274Z",
    transform: "translate(0)",
    fill: "#00784f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2,0V272.457h76.274L102.211,190.7H122.2L92.37,125.268h15L84.452,75H97.385Z",
    transform: "translate(13.073)",
    fill: "#086945"
  })), /*#__PURE__*/React.createElement("g", {
    id: "heroTree4",
    transform: "translate(1541.403 911.845)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.57,225.762l.119,18.2H76.469v-18.2Z",
    transform: "translate(11.494 46.695)",
    fill: "#736357"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.274,0,42.089,75H55.025L32.107,125.268h15L17.28,190.7H37.265L0,272.457H76.274Z",
    transform: "translate(0)",
    fill: "#00784f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2,0V272.457h76.274L102.211,190.7H122.2L92.37,125.268h15L84.452,75H97.385Z",
    transform: "translate(13.073)",
    fill: "#086945"
  })), /*#__PURE__*/React.createElement("g", {
    id: "heroTree6",
    transform: "translate(1839.067 982.972)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.57,225.762l.119,18.2H76.469v-18.2Z",
    transform: "translate(11.494 46.695)",
    fill: "#736357"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.274,0,42.089,75H55.025L32.107,125.268h15L17.28,190.7H37.265L0,272.457H76.274Z",
    transform: "translate(0)",
    fill: "#00784f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2,0V272.457h76.274L102.211,190.7H122.2L92.37,125.268h15L84.452,75H97.385Z",
    transform: "translate(13.073)",
    fill: "#086945"
  })), /*#__PURE__*/React.createElement("g", {
    id: "heroTree5",
    transform: "translate(1733.107 982.972)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.57,225.762l.083,12.639H70.087V225.762Z",
    transform: "translate(-8.987 -36.514)",
    fill: "#736357"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.98,0,29.235,52.091H38.22L22.3,87.011H32.72L12,132.464H25.884L0,189.248H52.98Z",
    transform: "translate(0)",
    fill: "#00784f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2,0V189.248h52.98L90.3,132.464h13.881L83.462,87.011H93.88L77.962,52.091h8.984Z",
    transform: "translate(-10.222)",
    fill: "#086945"
  })), /*#__PURE__*/React.createElement("g", {
    id: "heroTree1",
    transform: "translate(-72.073 1086.056)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.57,225.762l.083,12.639H70.087V225.762Z",
    transform: "translate(-8.987 -36.514)",
    fill: "#736357"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.98,0,29.235,52.091H38.22L22.3,87.011H32.72L12,132.464H25.884L0,189.248H52.98Z",
    transform: "translate(0)",
    fill: "#00784f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2,0V189.248h52.98L90.3,132.464h13.881L83.462,87.011H93.88L77.962,52.091h8.984Z",
    transform: "translate(-10.222)",
    fill: "#086945"
  })), /*#__PURE__*/React.createElement("g", {
    id: "heroTree2",
    transform: "translate(48.829 1061.229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.57,225.762l.059,8.951H65.851v-8.951Z",
    transform: "translate(-22.581 -91.741)",
    fill: "#736357"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.519,0,20.7,36.89h6.363L15.793,61.619h7.378L8.5,93.808h9.831L0,134.021H37.519Z",
    transform: "translate(0)",
    fill: "#00784f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2,0V134.021h37.519L82.39,93.808h9.83L77.549,61.619h7.378L73.654,36.89h6.362Z",
    transform: "translate(-25.682)",
    fill: "#086945"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroBottom);
export default __webpack_public_path__ + "static/media/hero-bottom.9dbcc11535e19ac9ed63c5b1df8ead1d.svg";
export { ForwardRef as ReactComponent };